// extracted by mini-css-extract-plugin
export default {"main":"sfa-z"};